export const DESKTOP_BREAKPOINT = "1024px";
export const DESKTOP_BREAKPOINT_NUMBER = 1024;
export const MOBILE_BREAKPOINT = "430px";
export const TABLET_BREAKPOINT = "768px";
export const MOBILE_BREAKPOINT_NUMBER = 430;
export const SMALL_MOBILE_BREAKPOINT = "380px";
